module.exports = __webpack_public_path__ + "static/media/feature-search-basic@2x.beac9b55.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/feature-search-basic@2x.png
// module id = 166
// module chunks = 0